import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import 'highcharts/modules/stock';
import 'highcharts/modules/no-data-to-display';
import { Options } from 'highcharts';
import { cloneDeep, defaultsDeep } from 'lodash-es';
import { HighchartsChartComponent } from 'highcharts-angular';
import { ChartWrapperComponent } from '@libs/vc-shared-ui-lib';

@Component({
    selector: 'vc-bar-chart',
    templateUrl: './bar-chart.component.html',
    styleUrls: ['./bar-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [HighchartsChartComponent, ChartWrapperComponent],
})
export class BarChartComponent {
    highcharts: typeof Highcharts = Highcharts;

    private chartInstance?: Highcharts.Chart;

    @Input()
    contentHeight!: string;

    @Input()
    loading = false;

    @Input()
    title = '';

    @Input()
    set options(options: Options) {
        const defaults = cloneDeep(BAR_CHART_DEFAULT_OPTIONS);
        const merged = defaultsDeep({}, options, defaults);

        this._options = cloneDeep(merged);
        this._updateChart();
    }
    get options() {
        return this._options;
    }
    private _options: Options = { ...BAR_CHART_DEFAULT_OPTIONS };

    @Input()
    height = '300px';

    @Input()
    formContainer = true;

    @Input()
    showHeader = true;

    onChartInstance(chart: Highcharts.Chart): void {
        this.chartInstance = chart;
        this._updateChart();
    }

    private _updateChart(): void {
        if (!this.chartInstance?.renderer) {
            return;
        }

        this.chartInstance.update(this._options, true, true);
    }
}

export const BAR_CHART_DEFAULT_OPTIONS: Options = {
    chart: {
        type: 'bar',
        borderWidth: 0,
    },
    credits: {
        enabled: false,
    },
    title: {
        text: '',
    },
    subtitle: {
        text: '',
    },
    yAxis: {
        min: 0,
        title: {
            text: '',
        },
    },
    series: [],
    tooltip: {
        outside: true,
    },
};
